<!--
================================================
Un composant qui affiche la liste des derniers pointages (sous la pointeuse)

Url d'accès : http://localhost:8080/fr/cronocloud-inc/timeclock

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="MyRecentActivityComp" >
        <div class="columns">
             <modal-timerecords-edition-comp></modal-timerecords-edition-comp>
            <div class="column">

                <div class="appTitle">
                    <font-awesome-icon :icon="['fas', 'stopwatch']" />
                    {{$t('pointagesRécents')}}
                </div>

                <!--  Bloc affiché en cas d'absence de timerecords-->
                <div class="appBloc  is-vcentered" id="blocNoTimerecord" v-show="timerecordsCount==0 && componentIsReady">
                    <span class="">{{$t('aucunPointage')}}</span>
                </div>

                <!--  Bloc placeholder affiché pendant le chargement des timerecords-->
                <div class="appBloc" id="blocLoadingTimerecord" v-show="!componentIsReady">

                    <table class="table is-fullwidth">
                        <tbody>
                            <loading-timerecord-comp v-for="index in 10" :key="index"></loading-timerecord-comp>
                        </tbody>
                    </table>

                </div>

                <!--  Bloc affichant la liste des timerecords-->
                <div class="" id="blocTimerecordsTable" v-show="componentIsReady">

                    <div v-for="(value,key) in timerecords" :key="value.slug">
                        <table class="appBloc table is-fullwidth trDaySummary" v-if="isANewDay(value, timerecords[key-1])" v-bind:id="'trDaySummary_'+$moment(value.timeIn).format('D-MM-YYYY')">

                            <thead>
                                <tr class="lineDay" >
                                    <th colspan="6" >
                                     <font-awesome-icon :icon="['far', 'calendar-alt']" class="icon" />

                                        <!-- // si la date est égale à aujourd'hui on affiche la chaîne "aujourd'hui"-->
                                        <span v-if="isToday(value.timeIn)">{{$t('aujourdhui') +' - '+formatDateWithDayName(value.timeIn, locale)}}</span>

                                        <!--  si la date est égale à hier'hui on affiche la chaîne "hier"-->
                                         <span v-else-if="isYesterday(value.timeIn)">{{$t('hier') +' - '+formatDateWithDayName(value.timeIn, locale)}}</span>

                                        <!--  sinon  affichage de la date au format "mardi 23 mai 2019"-->
                                        <span v-else> {{formatDateWithDayName(value.timeIn, locale)}} </span>

                                        <!-- affichage de la durée totale du jour-->
                                        <day-duration-comp v-bind:dayRef="value.timeIn"> </day-duration-comp>

                                    </th>
                                </tr>
                            </thead>

                        <tbody >


                            <!-- on boucle sur tous les tr et on affiche que ceux correspondant au jour du tr actuel dans la boucle (:key="value2.slug" est requis par le linter) -->
                            <timerecord-table-line-comp
                                    class="timerecordDetail"
                                    v-bind:timerecord="value2" :key="'trList2-' +value2.slug"
                                    v-for="(value2) in timerecords"
                                    v-if="isSameDay(value2.timeIn, value.timeIn)">
                            </timerecord-table-line-comp>

                        </tbody>
                    </table>
                    </div>

                    <div class="resultCount" v-if="timerecordsCount !==0"> {{ $tc("nbResultat",timerecordsCount) }} </div>


                    <div id="scrollTarget"></div>
                </div>


<!--                On affiche le bouton pour charger plus de tr si : le comp est prêt, si tous les tr n'ont pas déjà été affichés, si le nb de tr est différent de 0 et si initialLoadEmpty ne vaut pas true-->
                <a class="button is-rounded is-outlined"
                   id="loadMoreTimerecords"
                   v-bind:class="{'is-loading':isLoadingMore}"
                   v-on:click="loadMoreTimerecords(timerecordsCount+1, trNumberToLoad)"
                   v-show="componentIsReady && !trEndIsReached && timerecordsCount !==0 && initialLoadEmpty !== true">
                    <span>{{$t('voirPlus')}}</span>
                </a>

            </div>
        </div>
    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TimeMixin from "../mixins/TimeMixin.js";
    import LoadingTimerecordComp from "./PlaceholderTimerecordComp";
    import TimerecordTableLineComp from "./TimerecordTableLineComp";
    // import TaskTimerecordTableLineComp from "./TaskTimerecordTableLineComp";
    import DayDurationComp from "./DayDurationComp";
    import ModalTimerecordsEditionComp from "./ModalTimerecordsEditionComp";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'MyRecentActivity',
        components: {DayDurationComp, TimerecordTableLineComp, LoadingTimerecordComp,ModalTimerecordsEditionComp,},
 //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin,InterceptorMixin,TimeMixin, TrackingMixin],
        // components: {},
        data: function () {
            return {
                locale: this.$route.params.locale,
                componentIsReady : false, // indique quand le composant est prêt à être afficher
                trNumberToLoad: 20 , // le nombre de timerecords à charger à chaque appel à loadTimerecords()
                initialLoadEmpty: undefined, // indique si aucun tr n'ont été retournés au 1er chargement de la page
                isLoadingMore: false, // indique si le chargement de timerecords supplémentaires est en cours.
                trEndIsReached: false // indique si tous les timerecords de l'utilisateur sont chargés (pour désactiver le btn #loadMoreTimerecords)
                // =================================================================
            }
        },
        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                timerecords: state => state.MyRecentActivityComp.timerecords,
                trToEdit: state=>state.ModalTimerecordsEditionComp.timerecord
            }),


            //----------------------------------------------

            // other computed props :
            timerecordsCount: {
                get: function () {return this.timerecords.length},
            },


        },


        methods: {

            /**
             * Récupère des timerecords via l'api REST
             * @param offset Le nombre à partir duquel récupérer
             * @param limit Le nombre limite à récupérer
             **/
            loadTimerecords(offset = null, limit = null){

                this.isLoadingMore = true; // met le bouton #loadMoreTimerecords en statut loading
                let self = this;

                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.$auth.getUserSlug()}/timeRecords`,
                    {  params: {limit : limit, offset: offset, sort :'desc', type: 'excludeTask',workspace: self.$auth.getActiveWorkspace()},
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // si pas de résultat
                        if(response.data.length ===0){
                            self.initialLoadEmpty = true;

                            // on déclenche l'event pour afficher le welcom tour
                            self.sendNoTimrecord2LoadEvent()

                        }
                        else{
                            self.initialLoadEmpty = undefined;

                            // on boucle sur les résultats et on les ajoute au tableau de timerecords
                            response.data.forEach(function(element) {
                                self.timerecords.push(element)
                            });
                            self.$store.commit('UpdateMyRecentActivityComp', {
                                'timerecords' : self.timerecords
                            });

                            // désactivation du #loadMoreTimerecords si le nombre de tr chargé est un multiple de trNumberToLoad @todo refactorer methode
                            if (self.timerecordsCount % self.trNumberToLoad === 0){
                                self.trEndIsReached = false;
                            }
                            else {
                                self.trEndIsReached = true;
                            }
                        }

                        self.componentIsReady = true;
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0004'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetchibng timerecords', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error fetching MyRecentActivity timerecords"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error on fetching MyRecentActivity timerecords : ${error}`, 'error')

                        }
                    })
                    .then(function () {
                        self.isLoadingMore = false;

                    })

            },

            /**
             * Envoie l'event no_timerecord_2_load_event.
             * Utilisé par le WelcomeTourComp pour afficher le tour.
             **/
            sendNoTimrecord2LoadEvent: function(){
                this.$root.$emit('no_timerecord_2_load_event')
            },

            /**
             * Charge plus de timerecords (méthode charger depuis le bouton) #loadMoreTimerecords
             * @param offset Le nombre à partir duquel récupérer
             * @param limit Le nombre limite à récupérer
             **/
            loadMoreTimerecords(timerecordsCount, trNumberToLoad){

                this.loadTimerecords(timerecordsCount, trNumberToLoad)
                // tracking mixpanel
                this.$mixpanel.track("[MyRecentActivity] more timerecords loaded");
                this.ga4GlobalEventTrack('[MyRecentActivity] more timerecords loaded' , {})

            },
            /**
             * Retourne true si le nombre LoadedTrCount est un multiple de trNumberToLoad
             * Si ou cela indique que tous les timerecords sont chargés (utilisé pour masquer le bouton #loadMoreTimerecords)
             *
             * @param trNumberToLoad
             * @param LoadedTrCount
             * @returns {boolean}
             **/
            allTimerecordsLoaded(trNumberToLoad, LoadedTrCount){

                // if (self.timerecordsCount % self.trNumberToLoad === 0){
                //     self.trEndIsReached = false;
                // }
                // else {
                //     self.trEndIsReached = true;
                // }
                if (LoadedTrCount % trNumberToLoad=== 0){
                    return false
                }
                else {
                    return true
                }
            },


            /**
             * Retourne true si les timeIn des 2 timerecord sont différents
             * @param timerecord
             * @param previousTimerecord
             * @returns {boolean}
             */
            isANewDay(timerecord, previousTimerecord){

                // si pas de jour précédent
                if(previousTimerecord == null) {

                    return true
                }
                else {
                    // si le jour est diff du jour du timerecord précédent alors on retourne true
                    if(this.$moment(timerecord.timeIn).format('DD-MM-YYYY') != this.$moment(previousTimerecord.timeIn).format('DD-MM-YYYY')){
                        return  true
                    }
                    else{
                        return  false
                    }
                }

            },


            /**
             * Retourne true si date1 et date2 appartiennent au même jour (comparaison faites sur le début du jour)
             * @param dateTr
             * @returns {boolean}
             */
            isSameDay(date1, date2) {


                let timezone = this.user.timezone;

                date1 = this.$moment(date1).tz(timezone).startOf('day')
                date2 = this.$moment(date2).tz(timezone).startOf('day')

                // si date (dateTr.startOfDay == todayTimezone.startofDay alors today
                if (date1.format() == date2.format()) {
                    return true
                } else {
                    return false
                }

            },

            /**
             * Retourne true si le début du jour de dateTr est égal au début d'aujourd'hui
             * @param dateTr
             * @returns {boolean}
             */
            isToday(dateTr){

                let timezone = this.user.timezone;

                let date =      this.$moment(dateTr).tz(timezone).startOf('day')
                let todayRef =  this.$moment().tz(timezone).startOf('day')


                // si date (dateTr.startOfDay == todayTimezone.startofDay alors today
                if(date.format() == todayRef.format() ){
                    return true
                }

            },

            /**
             * Retourne true si le début du jour de dateTr est égal au début d'hier
             * @param dateTr
             * @returns {boolean}
             */
            isYesterday(dateTr){
                let timezone = this.user.timezone;

                let yesterdayRef = this.$moment().subtract('1','d').tz(timezone).startOf('day').format();

                if(this.$moment(dateTr).tz(timezone).startOf('day').format() == yesterdayRef ){
                    return true
                }
            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            // chargement initial des timerecords
                // si on a jamais chargé les tr dans le store on les charges...
            if(this.$store.state.MyRecentActivityComp.timerecords.length === 0){
                this.loadTimerecords(0,this.trNumberToLoad)

            }
            else{// ... on ne recharge pas si des timerecords sont déjà dans les store

                this.componentIsReady = true;

                // si tous les tr sont chargé on masque le bouton '#loadMoreTimerecords" via trEndIsReached
                if(this.allTimerecordsLoaded(this.trNumberToLoad,this.$store.state.MyRecentActivityComp.timerecords.length)){
                    this.trEndIsReached = true;
                }

            }

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #MyRecentActivityComp{
        margin-bottom: 5rem;
    }
    table{
        margin-bottom: 2rem;
    }
    .lineDay{
        // reprend la mise en forme de thead dans AppLayoutComp.vue (mais dans ce composant il peut y en avoir plusieurs dans un même tableau et ce n'est pas valide html)
            background: #f9f9f9;

            border: solid 1px #eeefef;
            th{
                color: $brandFourth;
            }
    }
    #blocTimerecordsTable{
        margin-bottom: 2rem;
        /*border:solid 1px crimson;*/
    }

    #blocNoTimerecord{
        border:dashed 1px #ddd;
        color:$brandFourth;
        font-size: 0.9rem;
        font-weight: bold;
        $height : 7rem;
        min-height: $height;
        line-height: $height;
        vertical-align: middle;
        text-align: center;
        background: #fff;
        margin-bottom: 2rem;
    }

    .resultCount{
        color: #ccc;
        font-size: 0.9rem;

    }
    #loadMoreTimerecords{
        padding: 1.3rem 1.5rem ;
        font-size: 0.9rem;
        color:#777;
     }

</style>
